export default __webpack_public_path__ + "static/media/news.a2dcd967.svg";